/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { ReactElement, ReactNode } from 'react';
import { styled } from 'styled-components';
import { theme } from '@motili/ui';
import config from '../../config';
import ProgressStepper from '../ProgressStepper/ProgressStepper';

interface CenteredContainerProps {
    children: ReactNode;
    isPDF?: boolean;
    hideProgressStepper?: boolean;
}

export default function CenteredContainer({
    children,
    isPDF,
    hideProgressStepper,
}: CenteredContainerProps): ReactElement {
    return (
        <>
            <Banner isPDF={isPDF}>
                <img
                    src={`${config.baseCDNURL}images/loginPage/transparent_new_logo.svg`}
                    style={{ height: '53px' }}
                    alt='Motili Logo'
                />
            </Banner>
            {isPDF ? (
                <PDFContainer>{children}</PDFContainer>
            ) : (
                <Container>
                    <>
                        {!hideProgressStepper && <ProgressStepper />}
                        {children}
                    </>
                </Container>
            )}
        </>
    );
}

const Container = styled.section`
    background-color: ${theme.color('white')};
    width: 600px;
    padding: 16px 40px 25px 40px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 10px 15px ${theme.color('grey500')};
    @media (max-width: 500px) {
        width: 100%;
        padding: 10%;
    }
`;

const PDFContainer = styled.section`
    background-color: ${theme.color('white')};
    width: 625px;
    padding: 50px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 3px 15px ${theme.color('grey500')};
    @media (max-width: 600px) {
        width: 90%;
        padding: 10%;
    }
`;

const Banner = styled.div<{ isPDF?: boolean }>`
    background-color: ${theme.color('blue100')};
    display: flex;
    justify-content: center;
    padding: 14px 0 13px 0;
    width: ${props => (props.isPDF ? '725px' : '680px')};
    @media (max-width: 500px) {
        width: 100%;
        padding: 14px 10% 13px 10%;
    }
`;
